import { Controller } from "@hotwired/stimulus"

const NUMERIC_PATTERN = /^-?\d+(\.\d+)?$/

export default class extends Controller {
  static targets = ["search", "row", "header"]

  connect() {
    this.sortState = { index: null, direction: 1 }
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      const matches = !query || row.textContent.toLowerCase().includes(query)
      row.classList.toggle("d-none", !matches)
    })
  }

  sort(event) {
    const header = event.currentTarget
    const index = Array.from(header.parentElement.children).indexOf(header)
    const tbody = this.rowTargets[0]?.parentElement
    if (!tbody) return

    const direction = this.sortState.index === index ? -this.sortState.direction : 1

    const rows = this.rowTargets.slice().sort((a, b) => {
      const cellA = a.children[index].textContent.trim()
      const cellB = b.children[index].textContent.trim()

      const cleanedA = cellA.replace(/[^0-9.-]/g, "")
      const cleanedB = cellB.replace(/[^0-9.-]/g, "")
      const isNumeric = NUMERIC_PATTERN.test(cleanedA) && NUMERIC_PATTERN.test(cleanedB)

      const comparison = isNumeric ? parseFloat(cleanedA) - parseFloat(cleanedB) : cellA.localeCompare(cellB)
      return comparison * direction
    })

    rows.forEach((row) => tbody.appendChild(row))

    this.headerTargets.forEach((th) => {
      const icon = th.querySelector("i")
      if (icon) icon.className = "bi bi-arrow-down-up text-muted small"
    })

    const icon = header.querySelector("i")
    if (icon) icon.className = direction === 1 ? "bi bi-sort-down-alt small" : "bi bi-sort-up-alt small"

    this.sortState = { index, direction }
  }
}
